require('../scss/disclaimer.scss');
var $ = require('jquery');
var common = require('./common');

var lang='';

$( document ).ready(function() {

    lang = common.initChangePage();

    if(lang == 'en'){
        $('#title').addClass('f-fHNLTP63ME');
    }else{
        $('#title').addClass('f-fZHBold');
    }






});







// WEBPACK FOOTER //
// ./src/disclaimer.js